var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 20,
  width: 37,
  height: 16,
  fill: "#c8d6e0"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 20,
  width: 5.3,
  height: 5.3,
  fill: "#aec1cf"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 14.6,
  y: 20,
  width: 5.3,
  height: 5.3,
  fill: "#aec1cf"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 25.2,
  y: 20,
  width: 5.3,
  height: 5.3,
  fill: "#aec1cf"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 35.8,
  y: 20,
  width: 5.2,
  height: 5.3,
  fill: "#aec1cf"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 9.3,
  y: 25.3,
  width: 5.3,
  height: 5.3,
  fill: "#aec1cf"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 30.5,
  y: 25.3,
  width: 5.3,
  height: 5.3,
  fill: "#aec1cf"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 30.6,
  width: 5.3,
  height: 5.4,
  fill: "#aec1cf"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 14.6,
  y: 30.6,
  width: 5.3,
  height: 5.4,
  fill: "#aec1cf"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 25.2,
  y: 30.6,
  width: 5.3,
  height: 5.4,
  fill: "#aec1cf"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 35.8,
  y: 30.6,
  width: 5.2,
  height: 5.4,
  fill: "#aec1cf"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 19.9,
  y: 25.3,
  width: 5.3,
  height: 5.3,
  fill: "#5c6870"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 18.5,
  y: 9,
  width: 6.5,
  height: 6.5,
  rx: 0.6,
  fill: "#aec1cf",
  transform: "rotate(-15 21.7 12.2)"
});

function SvgFloorRepairs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorRepairs);
export default __webpack_public_path__ + "static/media/floor-repairs.b96000dbae1790404ab42cf11b4fc80c.svg";
export { ForwardRef as ReactComponent };